module.exports = __webpack_public_path__ + "static/studio-jin-67f9f3d0e977b8222684ca6e4802085a.png";